<div class="loading-overlay" *ngIf="loading">
  <div class="loading-box">
    <i class="fas fa-spinner fa-spin loading-icon"></i>
    <span class="loading-texto -blue">{{ titulo }}</span>
    <span class="loading-subtexto -blue">{{ subtitulo }}</span>
  </div>
</div>
